// Imports => Utilities
import {AcLockObject} from '../utilities/ac-lock-object';

/* eslint-disable */
/* eslint react-app/import/no-webpack-loader-syntax: off */
import BRAND from '../assets/images/brand-1x.svg';
import LOADER from '../assets/images/loader-alpha-1x.svg';
import LOGO_ALPHA from '../assets/images/logo-alpha-1x.svg';
import LOGO_OMEGA from '../assets/images/logo-omega-1x.svg';

// Payment methods
import Amex1x from '../assets/images/payment-methods/pm-icon-amex-1x.svg';
import Bancontact1x from '../assets/images/payment-methods/pm-icon-bancontact-1x.svg';
import BancontactHorizontal1x from '../assets/images/payment-methods/pm-icon-bancontact-horizontal-1x.svg';
import Creditcard1x from '../assets/images/payment-methods/pm-icon-creditcard-1x.svg';
import GiroPay1x from '../assets/images/payment-methods/pm-icon-giropay-1x.svg';
import Ideal1x from '../assets/images/payment-methods/pm-icon-ideal-1x.svg';
import Klarna1x from '../assets/images/payment-methods/pm-icon-klarna-1x.svg';
import KlarnaFilled1x from '../assets/images/payment-methods/pm-icon-klarna-filled-1x.svg';
import Mastercard1x from '../assets/images/payment-methods/pm-icon-mastercard-1x.svg';
import MultiBanco1x from '../assets/images/payment-methods/pm-icon-multi-banco-1x.svg';
import Multi1x from '../assets/images/payment-methods/pm-icon-multi-1x.svg';
import MultiBancoSimple1x from '../assets/images/payment-methods/pm-icon-multi-banco-simple-1x.svg';
import MyBank1x from '../assets/images/payment-methods/pm-icon-mybank-1x.svg';
import Paypal1x from '../assets/images/payment-methods/pm-icon-paypal-1x.svg';
import PaypalHorizontal1x from '../assets/images/payment-methods/pm-icon-paypal-horizontal-1x.svg';
import PaypalSimple1x from '../assets/images/payment-methods/pm-icon-paypal-simple-1x.svg';
import Sepa1x from '../assets/images/payment-methods/pm-icon-sepa-1x.svg';
import SepaSimple1x from '../assets/images/payment-methods/pm-icon-sepa-simple-1x.svg';
import Sofort1x from '../assets/images/payment-methods/pm-icon-sofort-1x.svg';
import SofortSimple1x from '../assets/images/payment-methods/pm-icon-sofort-simple-1x.svg';
import Visa1x from '../assets/images/payment-methods/pm-icon-visa-1x.svg';
import Pi1x from '../assets/images/payment-methods/pm-icon-pis-1x.svg';
import Mandate1x from '../assets/images/payment-methods/pm-icon-mandate-1x.svg';
import ApplePay1x from '../assets/images/payment-methods/pm-icon-apple-pay-1x.svg';
import GooglePay1x from '../assets/images/payment-methods/pm-icon-google-pay-1x.svg';
import PaysafeCard1x from '../assets/images/payment-methods/pm-icon-paysafecard-1x.svg';
import In3 from '../assets/images/payment-methods/pm-icon-in3-1x.svg';
import Twint from '../assets/images/payment-methods/pm-icon-twint-1x.svg';
import Pis from '../assets/images/payment-methods/pm-icon-pis-1x.svg';

// Languages
import NL from '../assets/images/flags/nl.png';
import EN from '../assets/images/flags/en.png';
import DE from '../assets/images/flags/de.png';
import FR from '../assets/images/flags/fr.png';

export const VISUALS = AcLockObject({
  BRAND,
  LOADER,
  LOGO: {
    ALPHA: LOGO_ALPHA,
    OMEGA: LOGO_OMEGA,
  },
  PAYMENT_METHODS: {
    AMEX: Amex1x,
    BANCONTACT: Bancontact1x,
    BANCONTACT_HORIZONTAL: BancontactHorizontal1x,
    CREDITCARD: Creditcard1x,
    GIROPAY: GiroPay1x,
    IDEAL: Ideal1x,
    KLARNA: Klarna1x,
    KLARNA_FILLED: KlarnaFilled1x,
    MASTERCARD: Mastercard1x,
    MULTIBANCO: MultiBanco1x,
    MULTIBANCO_BRAND: MultiBancoSimple1x,
    MYBANK: MyBank1x,
    IN3: In3,
    TWINT: Twint,
    PIS: Pis,
    PAYPAL: Paypal1x,
    PAYPAL_HORIZONTAL: PaypalHorizontal1x,
    PAYPAL_BRAND: PaypalSimple1x,
    SEPA: Sepa1x,
    SEPA_BRAND: SepaSimple1x,
    SOFORT: Sofort1x,
    SOFORT_BRAND: SofortSimple1x,
    VISA: Visa1x,
    MULTI: Multi1x,
    PI: Pi1x,
    MANDATE: Mandate1x,
    APPLE_PAY: ApplePay1x,
    GOOGLE_PAY: GooglePay1x,
    PAYSAFECARD: PaysafeCard1x,
  },
  FLAGS: {
    NL: NL,
    EN: EN,
    DE: DE,
    FR: FR,
  },
});

export default AcLockObject({
  BRAND,
  LOADER,
  LOGO: {
    ALPHA: LOGO_ALPHA,
    OMEGA: LOGO_OMEGA,
  },
  PAYMENT_METHODS: {
    AMEX: Amex1x,
    BANCONTACT: Bancontact1x,
    BANCONTACT_HORIZONTAL: BancontactHorizontal1x,
    CREDITCARD: Creditcard1x,
    GIROPAY: GiroPay1x,
    IDEAL: Ideal1x,
    KLARNA: Klarna1x,
    KLARNA_FILLED: KlarnaFilled1x,
    MASTERCARD: Mastercard1x,
    MULTIBANCO: MultiBanco1x,
    MULTIBANCO_BRAND: MultiBancoSimple1x,
    MYBANK: MyBank1x,
    PAYPAL: Paypal1x,
    PAYPAL_HORIZONTAL: PaypalHorizontal1x,
    PAYPAL_BRAND: PaypalSimple1x,
    SEPA: Sepa1x,
    SEPA_BRAND: SepaSimple1x,
    SOFORT: Sofort1x,
    SOFORT_BRAND: SofortSimple1x,
    VISA: Visa1x,
    MULTI: Multi1x,
    PI: Pi1x,
    MANDATE: Mandate1x,
  },
});
